/**
 * 导出 Excel 用脱敏（与 api-server DesensitizeUtil 规则对齐）
 */

function toCodePoints(s: string): number[] {
    const out: number[] = [];
    for (let i = 0; i < s.length; ) {
        const cp = s.codePointAt(i);
        if (cp === undefined) break;
        out.push(cp);
        i += cp > 0xffff ? 2 : 1;
    }
    return out;
}

const HAN_CODEPOINT = /^\p{Script=Han}$/u;

function isHanCodePoint(cp: number): boolean {
    return HAN_CODEPOINT.test(String.fromCodePoint(cp));
}

function maskPersonNameSegment(segment: string): string {
    const cps = toCodePoints(segment);
    if (cps.length === 0) return '';
    if (cps.length === 1) return String.fromCodePoint(cps[0]);
    return String.fromCodePoint(cps[0]) + '*'.repeat(cps.length - 1);
}

/**
 * 姓名：去空白后全为汉字则整体按「首字 + *」；否则按空白分词，每词「首码点 + *」。
 */
export function maskPersonNameForExport(name: string | null | undefined): string {
    if (name == null || name.trim() === '') return '';
    const trimmed = name.trim();
    const compactNoSpace = trimmed.replace(/\s+/g, '');
    const cpsCompact = toCodePoints(compactNoSpace);
    if (
        cpsCompact.length > 0 &&
        cpsCompact.every((cp) => isHanCodePoint(cp))
    ) {
        return maskPersonNameSegment(compactNoSpace);
    }
    return trimmed.split(/\s+/).map(maskPersonNameSegment).join(' ');
}

/**
 * 电话：长度>7 保留前 3、后 4，中间等长 *（与后端 maskPhone 一致）
 */
export function maskPhoneForExport(phone: string | null | undefined): string {
    if (phone == null || phone.trim() === '') return '';
    const trimmed = phone.trim();
    if (trimmed.length <= 2) return '*'.repeat(trimmed.length);
    if (trimmed.length <= 7) {
        return (
            trimmed[0] +
            '*'.repeat(trimmed.length - 2) +
            trimmed.slice(-1)
        );
    }
    return (
        trimmed.slice(0, 3) +
        '*'.repeat(trimmed.length - 7) +
        trimmed.slice(-4)
    );
}

/**
 * `+国家码 ` 原样；仅对 phoneNumber 脱敏；分机原样接在末尾 `-${分机}`。
 */
export function maskInternationalPhoneForExport(
    phoneCountryCode: number | null | undefined,
    phoneNumber: string | null | undefined,
    extension: string | null | undefined
): string {
    const num = phoneNumber?.trim() ?? '';
    if (num === '') return '';
    const maskedNational = maskPhoneForExport(num);
    const ext = extension?.trim();
    const base =
        phoneCountryCode != null && phoneCountryCode !== undefined
            ? `+${phoneCountryCode} ${maskedNational}`
            : maskedNational;
    if (!ext) return base;
    return `${base}-${ext}`;
}
